import { useEffect, useState } from "react";

export function useDebouncedValue<T>(value: T, delayMs = 500): T {
	const [debounced, setDebounced] = useState(value);

	useEffect(() => {
		const timeout = setTimeout(() => setDebounced(value), delayMs);
		return () => clearTimeout(timeout);
	}, [value, delayMs]);

	return debounced;
}
